import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fakeDollarVars'
})
export class FakeDollarVarsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value.replace('${companyImageXlUrl}', 'https://www.mundimatdakmaterialen.nl/wp-content/uploads/2017/07/sample-logo-5.png');
    value = value.replace('${myTurn}', '28');
    value = value.replace('${deskTurn}', 'Desk');
    value = value.replace('${date}', '22/09/1990');
    value = value.replace('${hours}', '03:17');
    value = value.replace('${store}', 'Store');
    return value;
  }

}
